import axios from "../axios";

const login = async (email, password) => {
  try {
    const response = await axios.post(
      "/auth/sign_in",
      {
        email: email,
        password: password,
      },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const register = async (
  email,
  password,
  firstName,
  lastName,
  phonenum,
  bldgrp,
  dob,
  sex
) => {
  try {
    const response = axios
      .post("/auth/register", {
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        phonenum: phonenum,
        bldgrp: bldgrp,
        dob: dob,
        sex: sex,
      })
      .then((response) => {
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
    return response;
  } catch (error) {
    throw error;
  }
};

const sendOTP = async (email) => {
  try {
    const response = await axios.get(`/otp/sendOTP/${email}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    return response;
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
};

const verifyOTP = async (email, otp) => {
  try {
    const response = await axios.get(`/otp/verifyOTP/${email}/${otp}`);
    return response;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export { login, register, sendOTP, verifyOTP };
